import React, { Suspense } from 'react'
import { Switch, Route, AuthRoute, NotFound, Redirect } from '@fs/zion-router'
import ErrorBoundary from '@fs/zion-error-boundary'
import HomePageSkeleton from './components/HomePageSkeleton'

// Dynamically load components to reduce bundle size
// https://reactjs.org/docs/react-api.html#reactlazy

const HomePage = React.lazy(() => import('./components/HomePage'))
const DetailPage = React.lazy(() => import('./components/DetailPage'))
const TipsForParents = React.lazy(() => import('./components/TipsForParents'))

// Legacy redirect mappings - redirect old underscore paths to kebab-case
const legacyRedirects = {
  about_me: 'about-me',
  my_family: 'my-family',
  the_temple: 'the-temple',
}

// Generate redirect routes for legacy paths
const createLegacyRedirectRoutes = () => {
  return Object.entries(legacyRedirects).flatMap(([oldPath, newPath]) => [
    // Redirect base path: /about_me -> /about-me
    <Route key={`redirect-${oldPath}`} exact path={`/${oldPath}`} render={() => <Redirect to={`/${newPath}`} />} />,
    // Redirect with activity ID: /about_me/123 -> /about-me/123
    <Route
      key={`redirect-${oldPath}-activity`}
      exact
      path={`/${oldPath}/:activityId`}
      render={({ match }) => <Redirect to={`/${newPath}/${match.params.activityId}`} />}
    />,
  ])
}

export default function App() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<HomePageSkeleton />}>
        <Switch>
          {/* Legacy redirects for old underscore-based URLs */}
          {createLegacyRedirectRoutes()}

          <Route exact path="/" component={HomePage} />
          <AuthRoute exact path="/the-temple/:activityId" component={DetailPage} />
          <Route exact path="/:sectionName/:activityId" component={DetailPage} />
          <Route exact path="/tips" component={TipsForParents} />
          <AuthRoute path="/the-temple" component={HomePage} />
          <Route exact path="/:sectionName" component={HomePage} />
          <Route component={NotFound} />
        </Switch>
      </Suspense>
    </ErrorBoundary>
  )
}
